import { notifier } from '@geit/ui-components';
import { ENT_GOV_ACCOUNT, DC_FEATURE_CODES, IN_PROGRESS_URL, ESHOP_ACCESSIBLE_SEGMENTS } from './constants.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
const showFeatureUnavailable = () => {
  notifier.notify("You are currently accessing the view only version of Empower portal and you will not have access to applications hosted outside of Empower portal.", {
    title: "Feature unavailable",
    buttonText: "Ok, got it"
  });
};
const defaultWindowFeatures = {
  toolbar: "yes",
  scrollbars: "yes",
  resizable: "yes",
  top: 100,
  left: 100,
  width: 400,
  height: 400
};
const openExternalPage = function (url) {
  let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_self";
  let windowFeatures = arguments.length > 2 ? arguments[2] : undefined;
  let features = "";
  if (windowFeatures) {
    const mergedWindowFeatures = __spreadValues(__spreadValues({}, defaultWindowFeatures), windowFeatures);
    if ((mergedWindowFeatures == null ? void 0 : mergedWindowFeatures.left) && (mergedWindowFeatures == null ? void 0 : mergedWindowFeatures.top)) {
      mergedWindowFeatures.left = (window.screen.width - Number(mergedWindowFeatures == null ? void 0 : mergedWindowFeatures.width)) / 2;
      mergedWindowFeatures.top = (window.screen.height - Number(mergedWindowFeatures == null ? void 0 : mergedWindowFeatures.height)) / 2;
    }
    for (const [key, value] of Object.entries(mergedWindowFeatures || {})) {
      features += "".concat(key, "=").concat(value, ",");
    }
  }
  window.open(url, target, features);
};
const isGovAccount = sector => {
  return sector.toLowerCase().startsWith(ENT_GOV_ACCOUNT);
};
const transformDCUrl = (url, featureCode, sector) => {
  if (featureCode && sector) {
    if (isGovAccount(sector) && DC_FEATURE_CODES.includes(featureCode)) {
      return IN_PROGRESS_URL;
    }
  }
};
const isEshopAccessibleSegments = sector => {
  return ESHOP_ACCESSIBLE_SEGMENTS.some(s => sector.toLowerCase().startsWith(s));
};
const transformMenuUrl = _ref => {
  let {
    url,
    isEShopMenu,
    eshopBRNs,
    currentBRN,
    sector,
    featureCode
  } = _ref;
  if (sector && featureCode && isGovAccount(sector) && DC_FEATURE_CODES.includes(featureCode)) {
    return IN_PROGRESS_URL;
  }
  return isEShopMenu && !(eshopBRNs == null ? void 0 : eshopBRNs.some(b => b.brn === currentBRN)) && sector && !isEshopAccessibleSegments(sector) ? IN_PROGRESS_URL : url || "";
};
export { isEshopAccessibleSegments, isGovAccount, openExternalPage, showFeatureUnavailable, transformDCUrl, transformMenuUrl };